export const condition = {
  UPDATEACTIVITY: "UPDATEACTIVITY",
  LOGINTYPE: "LOGINTYPE",
  LANGUAGESELECT: "LANGUAGESELECT",
  MODALSHOWHIDE: "MODALSHOWHIDE",
  MODALCONTENT: "MODALCONTENT",
  nmae: "mehul",
  CLEARCHAT: "CLEARCHAT",
  TYPINGINDICATOR: "TYPINGINDICATOR",
  SETMESSGES: "SETMESSGES",
  UPDATEMESSGES: "UPDATEMESSGES",
  SETAUTOCOMPLETEDATA: "SETAUTOCOMPLETEDATA",
  RESETMESSAGES: "RESETMESSAGES",
  SETISFIRSTTIME: "SETISFIRSTTIME",
  UPDATECTA: "UPDATECTA",
  SETAUTHTOKEN: "SETAUTHTOKEN",
  SETMESSAGESUBMITTED: "SETMESSAGESUBMITTED",
  SETRECENTSEARCHES: "SETRECENTSEARCHES",
  UPDATELASTMESSAGE: "UPDATELASTMESSAGE",
  ISMESSAGESUBMITTED: "ISMESSAGESUBMITTED",
  SETMODE: "SETMODE",
  SETSOURCE: "SETSOURCE",
  SETTRANSCRIPTION: "SETTRANSCRIPTION",
  SETPROMPTS: "SETPROMPTS",
  // setting a nudge flow control
  SETNUDGEFLOW: "SETNUDGEFLOW",
  SETCHANNEL: "SETCHANNEL",
    // setting a digi nudge flow control
  SETDIGIGOLDFLOW: "SETDIGIGOLDFLOW",
};
